import axios from 'axios'
import request from '../utils/request'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18n from '../main'
Vue.use(VueI18n)

export class InboundApi {
  static requestUserId = '45678'
  static InboundFromUrl = {
    // queryInboundOrderUrl: "http://localhost:7001/inboundOrder/queryInboundOrders",
    // queryWarehouseUrl: "http://localhost:7001/inboundOrder/queryWarehouse",
    // queryOrderStatusUrl: "http://localhost:7001/inboundOrder/queryOrderStatus",
    // queryProcessNodes: "http://localhost:7001/inboundOrder/getPurchaseOrderProcessNodeList",
    // queryAegPurchaseDetailUrl: "http://localhost:7001/inboundOrder/queryPurchaseOrderTest",
    // queryPurchaseOrderItemsUrl: "http://localhost:7001/inboundOrder/queryPurchaseOrderItemsTest",
    // queryConsignOrderUrl: "http://localhost:7001/inboundOrder/queryConsignOrderTest",
    // queryLazadaProcessNodes: "http://localhost:7001/inboundOrder/queryOperateHistoryList",
    // queryLazadaPurchaseDetailUrl: "http://localhost:7001/inboundOrder/getServiceOrderDetail",
    //

    // downloadExcelTemplateUrl: 'http://localhost:7001/inboundOrder/downloadExcelTemplate',
    queryInboundOrderUrl: '/inboundOrder/queryInboundOrders',
    querySellerSKuUrl: '/inboundOrder/queryItemInventory',
    queryReplenishmentPlan: '/inboundOrder/queryReplenishmentPlan',
    queryWarehouseUrl: '/inboundOrder/queryWarehouse',

    queryOrderStatusUrl: '/inboundOrder/queryOrderStatus',

    downloadExcelTemplateUrl: '/inboundOrder/downloadExcelTemplate',
    queryProcessNodes: '/inboundOrder/getPurchaseOrderProcessNodeList',

    queryLzdPurchaseOrderDetail: '/inboundOrder/queryLzdPurchaseOrderDetail',
    queryAegPurchaseOrderDetail: '/inboundOrder/queryAegPurchaseOrderDetail',

    queryPurchaseOrderItemsUrl: '/inboundOrder/queryPurchaseOrderItems',

    queryLogisticOrderUrl: '/outboundOrder/getLogisticsLog',

    queryConsignOrderUrl: '/inboundOrder/queryConsignOrder',
    queryLazadaProcessNodes: '/inboundOrder/queryOperateHistoryList',
    queryShopNames: '/inboundOrder/queryShopNames',
    inboundOrderImportUrl: '/task/export/import',
    inboundCancelUrl: '/inboundOrder/cancelOrder',
    inboundOrderCancelUrl: '/inboundOrder/cancelOrder',
    inboundIoTypeUrl: '/inboundOrder/queryIoType',
    deliverTypeUrl: '/inboundOrder/queryDeliverType',
    sellerWareHouseUrl: '/inboundOrder/querySellerWarehouse',
    sellerWarehouseDetail: '/inboundOrder/querySellerWarehouseDetail',
    queryItemsUrl: '/inboundOrder/queryItems',
    createInboundUrl: '/inboundOrder/createInbound',
    createOutboundUrl: '/outboundOrder/createOutbound'

  }

  /**
   * 表格查询参数
   *
   */
  static inboundFromRequest = {
    inboundOrderNo: '',
    shopId: '',
    lbxOrderCode: '',
    warehouseId: '',
    orderStatusId: '',
    platformId: '',
    cFromTime: '',
    cToTime: '',
    ids: ''
  }

  /**
   * 表格查询参数
   *
   */
  static inboundPlanForm = {
    replenishOrderCode: '',
    shopId: '',
    scItemCode: '',
    lbxOrderCode: '',
    warehouseId: '',
    orderStatusId: '',
    platformId: '',
    cFromTime: '',
    cToTime: '',
    replenishSelected: ''
  }

  static skuColumn=[
    {
      title: 'Fulfilment SKU',
      dataIndex: 'cnSkuCode',
      width: '30%'
    },
    {
      title: 'Platform SKU',
      dataIndex: 'platformSkuId'
    },
    {
      title: 'Seller SKU',
      dataIndex: 'sellerSkuId'
    },
    {
      title: 'Sellable Inventory in Warehouse',
      dataIndex: 'goodQuantity'
    },
    {
      title: 'Fulfilment SKU Name',
      dataIndex: 'scItemName'
    },
    {
      title: 'Barcode',
      dataIndex: 'barcodes'
    },
    {
      title: 'Shelf Life',
      dataIndex: 'shelfLife'
    },
    {
      title: 'Serial Number',
      dataIndex: 'serialNumber'
    }
  ]
  static inboundPlanSkuTableColumn =[
    {
      title: 'Fulfilment SKU',
      dataIndex: 'cnSkuCode',
      width: '30%'
    },
    {
      title: 'Item Id',
      dataIndex: 'scItemId'
    },
    {
      title: 'Item Name',
      dataIndex: 'scItemName'
    },
    {
      title: 'Shelf Life',
      dataIndex: 'shelfLife'
    },
    {
      title: 'Serial Number',
      dataIndex: 'serialNumber'
    },
    {
      title: 'Requested Quantity',
      dataIndex: 'replQuantity',
      scopedSlots: {customRender: 'requestedQuantity'}

    },
    {
      title: 'operation',
      dataIndex: 'operation',
      scopedSlots: {customRender: 'operation'}
    }
  ]

  static inboundPlanSkuTableDataSource =[
    {
      key: '0',
      fulfilmentSKU: 'Edward King 0',
      sellerSku: '32',
      cnSkuName: 'London, Park Lane no. 0',
      requestedQuantity: 34
    },
    {
      key: '1',
      fulfilmentSKU: 'Edward King 1',
      sellerSku: '32',
      cnSkuName: 'London, Park Lane no. 1',
      requestedQuantity: 34

    }
  ]

  static inboundPlanTableColumn=[
    {
      title: '补货单号',
      dataIndex: 'replOrderNo',
      width: 180,
    },
    {
      title: '商家名称',
      dataIndex: 'sellerName',
      width: 100
    },
    {
      title: '货品名称',
      width: 200,
      dataIndex: 'scItemName'
    },
    {
      title: '仓库',
      dataIndex: 'destinationCode',
      width: 150
    },
    {
      title: '建议补货数量',
      width: 50,
      dataIndex: 'replQuantity'
    },
    {
      title: '创建时间',
      width: 100,
      dataIndex: 'gmtCreate'
    },
    {
      title: '操作',
      width: 80,
      fixed: 'right',
      scopedSlots: {customRender: 'action'}
    }
  ]

  /**
   * 获取aeg的节点变更
   *
   */
  static queryAegProcessNodes (purchaseOrderNo) {
    request({
      url: InboundApi.InboundFromUrl.queryProcessNodes,
      method: 'get',
      params: {
        purchaseOrderNo: purchaseOrderNo
      }
    }).then(response => {
      console.log(response.data.model)
      return response.data.model
    })
  }

  /**
   * 下载事件
   *
   */
  static DownLoadFile (url, params) {
    axios.post(url, params, {
      responseType: 'blob'
    }).then(response => {
      var blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' })
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = params.get('filename') // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 下载事件
   *
   */
  static GetDownLoadFile (url, params) {
    axios.get(url, params, {
      responseType: 'blob'
    }).then(response => {
      var blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' })
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = params.filename // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }).catch((error) => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/InboundApi.js